import React from 'react';
import { Button } from 'antd';
import { Link } from 'react-router-dom';
import { theme } from '../../../styles/theme';

const SecondaryButton = ({ 
  children, 
  onClick, 
  href, 
  to, 
  size = 'large',
  style = {},
  className = '',
  ...props 
}) => {
  const buttonStyle = {
    background: 'white',
    color: theme.colors.primary,
    border: `2px solid ${theme.colors.primary}`,
    borderRadius: '25px',
    height: '50px',
    padding: '0 30px',
    fontSize: '1.1rem',
    fontWeight: '600',
    fontFamily: theme.fonts.primary,
    transition: 'all 0.3s ease',
    ...style
  };


  // If 'to' prop is provided, render as Link, otherwise render as Button
  if (to) {
    return (
      <Link to={to}>
        <Button
          size={size}
          style={buttonStyle}
          className={className}
          onClick={onClick}
          {...props}
        >
          {children}
        </Button>
      </Link>
    );
  }

  return (
    <Button
      size={size}
      style={buttonStyle}
      className={className}
      onClick={onClick}
      href={href}
      {...props}
    >
      {children}
    </Button>
  );
};

export default SecondaryButton;
